import TypingMindAlternativePage from '@/components/Pages/TypingMindAlternativePage';

export default TypingMindAlternativePage;
